import script from "./InventoryIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryIcon.vue?vue&type=script&setup=true&lang=js"

import "./InventoryIcon.vue?vue&type=style&index=0&id=7ec06bdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec06bdc"]])

export default __exports__